import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=29035f00&scoped=true&"
import script from "./news_list.vue?vue&type=script&lang=js&"
export * from "./news_list.vue?vue&type=script&lang=js&"
import style0 from "./news_list.vue?vue&type=style&index=0&id=29035f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29035f00",
  null
  
)

export default component.exports